query getMarkdownContent($slug: String) {
  markdownContent(slug: $slug) {
    id
    title
    content
  }
}
